import { Switch, useRouteMatch, Route } from 'react-router-dom';
import { SecureMessageContextProvider } from './Context/SecureMessageContext';
import MessageDetails from './MessageDetailsPage/MessageDetails';
import SecureMessage from './SecureMessage';

function MessageRouterLead(props) {
  let { path } = useRouteMatch();
  return (
    <SecureMessageContextProvider {...props} isLeadSpecific>
      <Switch>
        <Route exact path={path} component={SecureMessage} />
        <Route path={`${path}/:message_id`} component={MessageDetails} />
      </Switch>
    </SecureMessageContextProvider>
  );
}

export default MessageRouterLead;
